export enum ThemeOptions {
  DARK = 'dark',
  LIGHT = 'light',
}

// The skins of a theme, format is {baseTheme}-{varientName}
export enum ThemeSkin {
  NONE = 'none',
  GREEN = 'light-green',
}

export enum ThemeSurface {
  PRIMARY = 'surface-primary', // default
  SECONDARY = 'surface-secondary',
  TERTIARY = 'surface-tertiary',
}
